<template>
  <div class="checkout__total">
    <div class="checkout__total-row">
      <div class="checkout__total-title">Полная стоимость заказа</div>
      <div class="checkout__total-value">{{formatPrice(totalPrice)}} <i class="rouble-sign">₽</i></div>
    </div>
    <div class="checkout__total-row" v-if="eqPrtice > 0">
      <div class="checkout__total-title">Доп. опции</div>
      <div class="checkout__total-value">{{formatPrice(eqPrtice * this.car.info.rent_period.rent_days)}} <i class="rouble-sign">₽</i></div>
    </div>
    <div class="checkout__total-row checkout__total-row--small" v-if="car.deposit > 0">
      <div class="checkout__total-title">Депозит</div>
      <div class="checkout__total-value">{{formatPrice(car.deposit)}} <i class="rouble-sign">₽</i></div>
    </div>
    <div class="checkout__total-row" v-if="car.online_payment_percent > 0">
      <div class="checkout__total-title">К оплате сейчас <a href="javascript:void(0)" content="Сейчас вы оплачиваете лишь аванс. Остальную часть нужно будет внести при получении автомобиля наличными или картой." v-tippy="{arrow : true}">Почему?</a></div>
      <div class="checkout__total-value">{{formatPriceFloat(totalPrice*car.online_payment_percent/100)}} <i class="rouble-sign">₽</i></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
import moment from 'moment';
export default {
    name: 'Place',
    props: ['car', 'cars','eqPrtice'],
    computed: {
      totalPrice() {
        return parseInt(this.car.rate_subtotal)+parseInt(this.eqPrtice)*parseInt(this.car.info.rent_period.rent_days)+parseInt(this.car.extras.airport_fee)+parseInt(this.car.extras.drop_off_location_fee)+parseInt(this.car.extras.pick_up_location_fee)+parseInt(this.car.extras.out_working_hours_fee)+parseInt(this.car.extras.return_fee);
      }
    },
    methods: {
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      formatPriceFloat(price) {
        price = price.toFixed(2);
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
    }
}
</script>
